import { render, staticRenderFns } from "./ifilawtj.vue?vue&type=template&id=4f9d26fe&scoped=true&"
import script from "./ifilawtj.vue?vue&type=script&lang=js&"
export * from "./ifilawtj.vue?vue&type=script&lang=js&"
import style0 from "./ifilawtj.vue?vue&type=style&index=0&id=4f9d26fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d26fe",
  null
  
)

export default component.exports